import React, { useContext } from 'react';
import defaultStyle from './index.module.scss';
import soyRappiLogo from '../../../assets/soy-rappi-logo.png';
import Avatar from '../../../assets/avatar.svg';
import homeWallpaper from '../../../assets/wallpaper-ds.png';
import AvatarProfile from '../../../assets/avatarProfile.svg';
import CardRT from '../../../assets/card-rappi.svg';
import { perfilSatContext } from '../../../context/perfil.sat.context';
import { useNavigate } from 'react-router-dom';

const Home: React.FC = () => {
  const { userProfile } = useContext(perfilSatContext);

  const browse = useNavigate();

  const goToUploadFiles = () => {
    browse('/upload-files');
  };

  return (
    <div className={defaultStyle.container}>
      <div className={defaultStyle.headerContainer}>
        <img
          src={soyRappiLogo}
          alt={'soyRappiLogo'}
          className={defaultStyle.logoPosition}
        />
        <div className={defaultStyle.avatarContainer}>
          <div className={defaultStyle.borderRight}></div>
          <img
            src={Avatar}
            alt={'Avatar'}
            style={{
              margin: '10px 0 0 10px'
            }}
          />
          <div className={defaultStyle.avatarName}>
            {userProfile.profile.first_name}
          </div>
        </div>
      </div>
      <div className={defaultStyle.homeContainer}>
        <div className={defaultStyle.avatarCardContainer}>
          <img
            src={homeWallpaper}
            alt={'homeWallpaper'}
            className={defaultStyle.wallPaperSize}
          />
        </div>
        <div className={defaultStyle.avatarProfileContainer}>
          <img
            src={AvatarProfile}
            alt={'AvatarProfile'}
            className={defaultStyle.avatarProfilePosition}
          />
          <div className={defaultStyle.avatarProfileName}>
            {userProfile.profile.first_name} {userProfile.profile.last_name}
          </div>
          <div className={defaultStyle.CourierIdContainer}>
            <div className={defaultStyle.CourierIdRow}>
              <img
                src={CardRT}
                alt={'CardRT'}
              />
              <div className={defaultStyle.courierId}>
                ID: {userProfile.profile.id}
              </div>
            </div>
            <div className={defaultStyle.courierAuthorized}>
              Rappitendero autorizado
            </div>
          </div>
          <div className={defaultStyle.containerInstructions}>
            <div className={defaultStyle.instructionsTitle}>
              Registro de documentos fiscales para poder facturar
            </div>
            <div className={defaultStyle.instructionsDetails}>
              Recuerda tener descargado previamente tus sellos y FIEL para
              comenzar
            </div>
            <button className={defaultStyle.button} onClick={goToUploadFiles}>
              Cargar documentos fiscales
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
